import { strCamelCase } from "@hydrosoft/utils";
export function isKey(x, k) {
    return k in x;
}
// Funkce pro generování vlastních výchozích barev
export function generateDefaultColors(count, transparency = 0.5) {
    const defaultColors = [];
    // Paleta barev použitá v Chart.js
    const chartJsDefaultColors = [
        `rgba(255, 99, 132, ${transparency})`,
        `rgba(255, 159, 64, ${transparency})`,
        `rgba(255, 205, 86, ${transparency})`,
        `rgba(75, 192, 192, ${transparency})`,
        `rgba(54, 162, 235, ${transparency})`,
        `rgba(153, 102, 255, ${transparency})`,
        `rgba(201, 203, 207, ${transparency})`,
    ];
    for (let i = 0; i <
        (count <= chartJsDefaultColors.length
            ? count
            : chartJsDefaultColors.length); i++) {
        defaultColors.push(chartJsDefaultColors[i]);
    }
    if (count > chartJsDefaultColors.length) {
        for (let i = chartJsDefaultColors.length - 1; i < count; i++) {
            defaultColors.push(`rgba(0, ${i * 50}, 0, ${transparency})`);
        }
    }
    return defaultColors;
}
export function getIcon(id = "data", size = 22) {
    return `<svg class="icon" style="width: ${size.toString()}px; height: ${size.toString()}px;">
				<use href="../chart-icons.svg#${id}"></use>
			</svg>`;
}
export function downloadFileName(title, subtitle) {
    let fName = "myChart";
    if (title !== "undefined")
        fName = strCamelCase(title);
    if (subtitle !== "undefined")
        fName += "_" + strCamelCase(subtitle);
    return fName;
}
function formatDateString(datumXt) {
    const dtx = new Date(datumXt);
    let datumXstr = dtx.getDate().toString() +
        "." +
        (dtx.getMonth() + 1).toString() +
        "." +
        dtx.getFullYear().toString().slice(-2);
    if (!(dtx.getHours() === 0 && dtx.getMinutes() === 0)) {
        datumXstr +=
            " " +
                (dtx.getHours() < 10
                    ? "0" + dtx.getHours().toString()
                    : dtx.getHours().toString());
        datumXstr +=
            ":" +
                (dtx.getMinutes() < 10
                    ? "0" + dtx.getMinutes().toString()
                    : dtx.getMinutes().toString());
    }
    return datumXstr;
}
export function formatTicks(fstring) {
    let reVal = fstring;
    if (typeof fstring !== "number") {
        const dtStr = Date.parse(fstring);
        if (!isNaN(dtStr)) {
            reVal = formatDateString(fstring);
        }
    }
    return reVal;
}
export function ticksFormatter(scale, tickValue) {
    return typeof tickValue === "number"
        ? formatTicks(scale.getLabelForValue(tickValue))
        : "";
}
//# sourceMappingURL=HelpersFce.js.map